import { gql } from "@apollo/client";

export const getApiByOrganizationId = gql`
  query GetApiIntegrationByOrganizationId {
    getApiIntegrationByOrganizationId {
      id
      isLive
      publicKeyTest
      secretKeyTest
      encryptionKeyTest
      publicKeyLive
      secretKeyLive
      encryptionKeyLive
      meta
      organizationId
      createdAt
      updatedAt
    }
  }
`;
